import { filterConfiguration } from 'app/components/filters/filters-panel/filter-configuration';
import { FilterDomain } from './filter-domain';
import { endpoint } from 'app/area/filters/constants';
import { FilterTypes } from 'app/components/filters/types';
import { customFilterFieldPostfix } from 'app/components/filters/filters-panel/constants';
import { userProfileConditionMapper } from 'app/components/filters/filters-panel/filter-types/filter-domain/user-profile';
import { EditingValues } from 'app/components/filters/filters-panel/types';
import { getDefaultConditionTypesValueData } from '../default-condition-types-value-data';

export const myPersonConfiguration = {
  [FilterTypes.Person]: filterConfiguration(
    FilterDomain,
    endpoint.filterOptionsFor,
    [customFilterFieldPostfix.userProfile]
  )
};

export const myPersonConditionMapper = (editingValues: EditingValues) =>
  userProfileConditionMapper(editingValues, FilterTypes.Person, getDefaultConditionTypesValueData);
